import { ListSortBy } from '@core/models/common/list-sort-by';
import { IListState, initialListState } from '../shared/list/list.state';
import { ListSortDirection } from '@core/models/common/list-sort-direction';

export interface IBillingState {
    key: any;
    billing: any;
    subscription: any;
    estimate: any;
    isBillingFetching: boolean;
    isKeyFetching: boolean;
    isEstimateFetching: boolean;
    isUsageReportFetching: boolean;
    invoices: IListState;
    users: IListState;
    report: any;
}


export function initialBillingState(): IBillingState {
    return {
        key: null,
        billing: null,
        subscription: {},
        estimate: null,
        isBillingFetching: false,
        isKeyFetching: false,
        isEstimateFetching: false,
        isUsageReportFetching: false,
        invoices: {
            ...initialListState,
            sortBy: ListSortBy.TIME,
            sortDirection: ListSortDirection.DESCENDING,
        },
        users: { ...initialListState, sortBy: null },
        report: null,
    };
}
